import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Contact Us")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "d-flex justify-content-end",
      "data-kt-customer-table-toolbar": "base"
    })
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: contact }) => [
              _createTextVNode(_toDisplayString(contact.id), 1)
            ]),
            "cell-fullname": _withCtx(({ row: contact }) => [
              _createTextVNode(_toDisplayString(contact.name), 1)
            ]),
            "cell-phone": _withCtx(({ row: contact }) => [
              _createTextVNode(_toDisplayString(contact.phone), 1)
            ]),
            "cell-email": _withCtx(({ row: contact }) => [
              _createElementVNode("a", {
                href: `mailto:${contact.email}`,
                class: "text-gray-600 text-hover-primary mb-1"
              }, _toDisplayString(contact.email), 9, _hoisted_4)
            ]),
            "cell-createdDate": _withCtx(({ row: contact }) => [
              _createTextVNode(_toDisplayString(contact.createdAt), 1)
            ]),
            "cell-actions": _withCtx(({ row: conact }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.overViewContact(conact.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ])
              ], 8, _hoisted_5)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}